export const SEARCH = 'SEARCH'

export default {
    SEARCH
}
